import Legal from "@/js/components/legal/Legal";
import LegalDisclaimer from "@/js/components/legal/LegalDisclaimer";
import PrivacyPolicy from "@/js/components/legal/PrivacyPolicy";
import CookiesPolicy from "@/js/components/legal/CookiesPolicy";
import LimitationOfLiability from "@/js/components/legal/LimitationOfLiability";
import ReturnsPolicy from "@/js/components/legal/ReturnsPolicy";
import ShippingAndDelivery from "@/js/components/legal/ShippingAndDelivery";

const routes = [
    {
        path: "/legal",
        component: Legal,
        children: [
            // {
            //     path: "/",
            //     redirect: { name: 'legal.legal-disclaimer'},
            // },
            {
                paths: {
                    es: 'condiciones-legales',
                    en: 'legal-disclaimer',
                    fr: 'conditions-legales',
                    de: 'rechtliche-bedingungen',
                },
                name: "legal.legal-disclaimer",
                component: LegalDisclaimer
            },
            {
                paths: {
                    es: 'politica-de-privacidad',
                    en: 'privacy-policy',
                    fr: 'politique-de-confidentialite',
                    de: 'datenschutzrichtlinie',
                },
                name: "legal.privacy-policy",
                component: PrivacyPolicy
            },
            {
                paths: {
                    es: 'politica-de-cookies',
                    en: 'cookies-policy',
                    fr: 'politique-de-cookies',
                    de: 'cookie-richtlinie',
                },
                name: "legal.cookies-policy",
                component: CookiesPolicy
            },
            {
                paths: {
                    es: 'responsabilidad-limitada',
                    en: 'limitation-of-liability',
                    fr: 'responsabilite-limitee',
                    de: 'beschrankte-haftung',
                },
                name: "legal.limitation-of-liability",
                component: LimitationOfLiability
            },
            {
                paths: {
                    es: 'politica-de-devoluciones',
                    en: 'returns-policy',
                    fr: 'politique-de-retour',
                    de: 'ruckgaberecht',
                },
                name: "legal.returns-policy",
                component: ReturnsPolicy
            },
            {
                paths: {
                    es: 'envio-y-devoluciones',
                    en: 'shipping-and-delivery',
                    fr: 'expedition-et-retours',
                    de: 'versand-und-rücksendungen',
                },
                name: "legal.shipping-and-delivery",
                component: ShippingAndDelivery
            },
            {
                path: '*',
                redirect: { name: 'legal.legal-disclaimer' }
            }
        ]
    }
];

for (let route of routes[0].children) {
    if (route.path) {
        continue;
    }
    const path = route.paths[window.appLocale];
    if (!path) {
        throw new Error('Route not found');
    }
    route.path = path;
}
export default routes;
